<template>
    <nav aria-label="Table navigation" class="my-3">
        <ul class="pagination justify-content-center gap-2">
            <li class="page-item" :class="{ disabled: currentPage === 1 || contentLoading }">
                <a class="page-link rounded bi bi-arrow-bar-left" @click="goToPage(1)" v-if="currentPage !== 1"></a>
                <span class="page-link rounded bi bi-arrow-bar-left" v-else></span>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === 1 || contentLoading }">
                <a class="page-link rounded bi bi-arrow-left-short" @click="goToPage(currentPage - 1)" v-if="currentPage !== 1"></a>
                <span class="page-link rounded bi bi-arrow-left-short" v-else></span>
            </li>
            <li class="page-item" v-for="(page, index) in visiblePages" :key="index" :class="{ active: currentPage === page, disabled: page == '...' || contentLoading }">
                <a class="page-link rounded" @click="goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages || contentLoading }">
                <a class="page-link rounded bi bi-arrow-right-short" @click="goToPage(currentPage + 1)" v-if="currentPage !== totalPages"></a>
                <span class="page-link rounded bi bi-arrow-right-short" v-else></span>
            </li>
            <li class="page-item" :class="{ disabled: currentPage === totalPages || contentLoading }">
                <a class="page-link rounded bi bi-arrow-bar-right" @click="goToPage(totalPages)" v-if="currentPage !== totalPages"></a>
                <span class="page-link rounded bi bi-arrow-bar-right" v-else></span>
            </li>
        </ul>
    </nav>
</template>
  
<script setup>
import { ref, computed, watch } from 'vue';

const props = defineProps({
    totalItems: Number,
    currentPage: Number,
    itemsPerPage: Number,
    contentLoading: Boolean
});

const emit = defineEmits();
const currentPageRef = ref(props.currentPage);
const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage));

const visiblePages = computed(() => {
    const maxVisible = 3;
    const total = totalPages.value;
    const current = currentPageRef.value;
    const pagesArray = [];

    if (total <= maxVisible) {
        for (let i = 1; i <= total; i++) {
            pagesArray.push(i);
        }
    } else if (current <= maxVisible - 1) {
        for (let i = 1; i <= maxVisible; i++) {
            pagesArray.push(i);
        }
        pagesArray.push('...');
    } else if (current >= total - maxVisible + 2) {
        pagesArray.push('...');
        for (let i = total - maxVisible + 1; i <= total; i++) {
            pagesArray.push(i);
        }
    } else {
        pagesArray.push('...');
        pagesArray.push(current - 1);
        pagesArray.push(current);
        pagesArray.push(current + 1);
        pagesArray.push('...');
    }

    return pagesArray;
});

watch(() => props.currentPage, (newPage) => {
    currentPageRef.value = newPage;
});

const goToPage = (page) => {
    if (!props.contentLoading && page !== currentPageRef.value && page >= 1 && page <= totalPages.value) {
        currentPageRef.value = page;
        emit('update:currentPage', page);
    }
};
</script>

<style scoped lang="scss">
.page-item {
    cursor: pointer;

    &.disabled {
        cursor: default;
    }
}
</style>
  